
var attachmentServiceObj =
{
    getAllAttachments(uploadParams) {
        return axios.get("/api/attachment/" + uploadParams.targetType + '/' + uploadParams.targetId);
    },
    downloadAttachment(id) {
        return axios.get("/api/attachment/" + id);
    },
    deleteAttachment(id) {
        return axios.delete("/api/attachment/" + id);
    }
}

export const attachmentService = attachmentServiceObj;
